export const LICENSE_PAUSE_REQUEST_FETCH = 'LICENSE_PAUSE_REQUEST_FETCH'
export const LICENSE_PAUSE_REQUEST_SUCCESS = 'LICENSE_PAUSE_REQUEST_SUCCESS'
export const LICENSE_PAUSE_REQUEST_FAIL = 'LICENSE_PAUSE_REQUEST_FAIL'
